import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

const isValidUrl = (url) => {
  try {
    new URL(url);
  } catch (e) {
    return false;
  }
  return true;
};

const validationSchema = yup.object({
  link: yup
    .string()
    .test('is-url-valid', 'settings.crm.validation.notUrl', (value) =>
      isValidUrl(value)
    )
    .required('settings.crm.validation.baseUrl'),
  // key: yup.string().required('settings.crm.validation.token'),
});

const WarehouseIntegration = (props) => {
  const { open, setOpen, refetch = () => {}, data } = props;
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      link: '',
      // key: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // const body = { ...values };
      // if (!data?.id) {
      //   delete body.key;
      // }
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        '/admin/integration/warehouseupdate',
        'Ombor integratsiyasi muvaffaqiyatli saqlandi',
        null,
        true,
        handleFinishRequest
      );
    },
  });

  useEffect(
    () => {
      if (data?.id) {
        formik.setValues({
          link: data?.link,
          // key: data?.key,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, open]
  );

  const handleFinishRequest = () => {
    refetch();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{ className: '!base-border !shadow-none' }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id='alert-dialog-title'>
        <span>
          {t(
            `settings.integration.${
              data?.id ? 'editModal' : 'addModal'
            }.warehouse`
          )}
        </span>
        <div className='close-btn-wrapper'>
          <IconButton variant='onlyIcon' color='primary' onClick={handleClose}>
            <i className='bi bi-x' />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className='!max-w-[600px]'>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                duration={0}
                label={t('common.fields.url')}
                fieldName='link'
                formik={formik}
              />
            </Grid>

            {/* {data?.id ? null : (
              <Grid item={true} lg={12} sm={12} xs={12}>
                <FormTextField
                  duration={0}
                  label={t('common.fields.token')}
                  fieldName='key'
                  formik={formik}
                  multiline
                  rows={3}
                />
              </Grid>
            )} */}

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                duration={0}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(WarehouseIntegration);
